import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown';
import { Document } from '@contentful/rich-text-types';
import { SetStateAction } from 'react';

// This function is necessary when 'long text field' is used in contentful and we wish to retain uls, headings, etc..
// let's convert MD to rich text and use <RichText /> component to render out the entry.
export const convertMDToRichText = async (
  mdString: string,
  cb: React.Dispatch<SetStateAction<Document | null>>,
): Promise<void> => {
  try {
    const richTextHtml = await richTextFromMarkdown(mdString);
    if (richTextHtml) cb(richTextHtml);
  } catch (e) {
    console.error(e);
  }
};
